import { createSlice } from "@reduxjs/toolkit";
import { contactService } from "../../services/siteContentService";
import { createCustomAsyncThunk, defaultEntityAdapter } from "../utils";


export const getSiteContacts = createCustomAsyncThunk(
    "contact_info/get",
    async params => await contactService.get(params)
)


const siteContactSlice = createSlice({
    name: "siteContacts",
    initialState: defaultEntityAdapter.getInitialState({
        isLoading: true,
        error: null
    }),

    extraReducers: builder => {
        builder
            .addCase(getSiteContacts.pending, state => { state.isLoading = true })
            .addCase(getSiteContacts.fulfilled, ( state, action ) => {
                defaultEntityAdapter.setAll(state, action.payload)
                state.isLoading = false
            })
            .addCase(getSiteContacts.rejected, ( state, action ) => {
                state.isLoading = false
                state.error = action.error
            })
    }
});

export const siteContactSelector = defaultEntityAdapter.getSelectors(x => x.site.siteContacts)

export default siteContactSlice.reducer